import { LevelType } from "gen/ApiClient";

export const LevelTypeRecord: Record<LevelType, string> = {
    Expert: 'Expert',
    Medium: 'Gemiddeld',
    Starter: 'Beginner'
}